import { css } from 'styled-components'

const DeviceSizes = {
    phone: 576,
    tablet: 768,
    desktop: 992,
    large: 1200,
    xlarge: 1600,
}

const media = Object.keys(DeviceSizes).reduce((finalMedia, size) => {
    return {
        ...finalMedia,
        [size]: function (...args) {
            return css`
                @media(min-width: ${DeviceSizes[size]}px){
                    ${css(...args)}
                }
            `
        }
    }
}, {})

export default media